import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=c0506366&scoped=true&"
import script from "./Webhook.vue?vue&type=script&lang=js&"
export * from "./Webhook.vue?vue&type=script&lang=js&"
import style0 from "./Webhook.vue?vue&type=style&index=0&id=c0506366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0506366",
  null
  
)

export default component.exports